import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import LandOwnershipTypesDt from '@/services/dataTransferModules/landOwnershipTypesDt'

export default function useLandOwnershipTypes(params = {}) {
	const landOwnershipTypesDt = new LandOwnershipTypesDt()

	const { t: $t } = useI18n()

	const defaults = {
		fieldsCreating: {
			name: '',
		},
		fieldsToPatch: [
			'name',
		],
	}

	const {
		loadEntityFlags: flags,

		entities: landOwnershipTypes,
		getEntities: getLandOwnershipTypes,

		createEntity: createLandOwnershipType,

		entity: landOwnershipType,
		getEntity: getLandOwnershipType,

		entityPopup: landOwnershipTypePopup,
		getEntityPopup: getLandOwnershipTypePopup,

		entityPreview: landOwnershipTypePreview,
		getEntityPreview: getLandOwnershipTypePreview,

		patchEntity: patchLandOwnershipType,
		updateEntity: putLandOwnershipType,

		deleteEntity: deleteLandOwnershipType,
	} = useBlProviders(
		landOwnershipTypesDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Error loading land ownership types'),

				showErrorNotificationForCreatingEntity: true,
				errorNotificationTextForCreatingEntity: $t('Error when creating a land property type'),

				showErrorNotificationForLoadingOneEntity: true,
				errorNotificationTextForLoadingOneEntity: $t('Error loading land property type'),

				showErrorNotificationForUpdatingEntity: true,
				errorNotificationTextForUpdatingEntity: $t('Error when editing the property type of a land plot'),

				showErrorNotificationForDeletingEntity: true,
				errorNotificationTextForDeletingEntity: $t('Error when deleting property type of land plot'),
			},
			params,
		),
	)

	return {
		flags,
		landOwnershipTypes,
		landOwnershipType,
		landOwnershipTypePreview,
		landOwnershipTypePopup,
		defaults,

		getLandOwnershipTypes,
		getLandOwnershipType,
		getLandOwnershipTypePreview,
		getLandOwnershipTypePopup,
		createLandOwnershipType,
		putLandOwnershipType,
		patchLandOwnershipType,
		deleteLandOwnershipType,
	}
}
